<template>
  <div class="pdf_box">
    <Popup v-model="popup_show" position="bottom" />
    <!--<HeadNavBar></HeadNavBar>-->
    <div v-if="no_yes_Status=='30001024'" class="pdf_body">
      <div v-if="no_yes_Status=='30001024'" class="pdf_box">
        <Row v-for="(pdf_list_value,pdf_list_value_index) in pdf_list" :key="pdf_list_value_index">
          <div :class="[`pdf_${pdf_list_value_index}`]" />
        </Row>
        <div>
          <Row class="pdf_h5_btn_box">
            <p class="pdf_h5_btn_text">请确认无误后，进行司法确认</p>
            <Row class="popup_box">
              <p class="popup_box_text">确认无误请同意司法确认，并进行签字。若不同意此调解内容请拒绝。</p>
              <Col span="12" class="popup_box_btn">
                <Button block type="danger" @click="GstConfirmApply('false')">拒绝</Button>
              </Col>
              <Col span="12" class="popup_box_btn">
                <Button block type="primary" @click="GstConfirmApply('true')">同意</Button>
              </Col>
            </Row>
            <!--<Button type="danger"-->
            <!--block-->
            <!--@click="AxiosPosType">司法确认</Button>-->
          </Row>
        </div>
      </div>
    </div>
    <Row v-else-if="is_address_edit" class="address_box">
      <Field
        v-model="areaList_value_detailed"
        type="textarea"
        label="地址"
        placeholder="请输入您的地址"
      />
      <Row class="area_btn ">
        <Button class="btn_bottom" block color="#F12020" @click="AreaYes">确认送达地址</Button>
      </Row>

      <!--<Field @focus="GpsClickInput" v-model="areaList_value" label="地址" placeholder="请选择地址" />-->
      <!--<Field  v-model="areaList_value_detailed" label="详细地址" placeholder="街道门牌、楼层房号等信息" />-->
      <!--<Row class="area_box" v-if="gps_is_area">-->
      <!--<Area  :value="areaList_value"-->
      <!--@confirm="AreaConfirm"-->
      <!--@change="AreaonChange"-->
      <!--@cancel="AreaonCancel"-->
      <!--ref="myArea"-->
      <!--title="请选择地址"-->
      <!--:area-list="areaList"-->
      <!--:columns-placeholder="['请选择', '请选择', '请选择']"-->
      <!--/>-->
      <!--</Row>-->
    </Row>
    <Row v-else-if="face_is_type" class="is_id_box ">
      <p class="face_is_type_tile">人脸识别</p>
      <p class="face_is_type_text">{{ face_is_text }}</p>
      <div class="face_is_type_img_box">
        <div class="face_is_type_img jz">
          <VanImage
            fit="contain"
            width="160"
            height="160"
            :src="require('@/assets/image/face_is_type.png')"
          />
        </div>
      </div>
      <Row class="btn_s ">
        <Button class="btn_bottom" block color="#F12020" @click="SetWindowUrl">人脸识别</Button>
      </Row>
    </Row>
    <Row v-else-if="no_yes_Status=='30001026'" class="is_id_box ">
      <p class="face_is_type_tile">您已拒绝本次调解</p>
      <p class="face_is_type_text">如需再次调解请进行申请</p>
      <div class=" jz">
        <VanImage
          fit="contain"
          width="260"
          height="260"
          :src="require('@/assets/image/yes_no.png')"
        />
      </div>
    </Row>
    <Row v-else-if="no_yes_Status=='30001027' ||no_yes_Status=='30001028' || no_yes_Status=='30001029'" class="is_id_box ">
      <p class="face_is_type_tile">您已完成本次调解程序</p>
      <p class="face_is_type_text">请等待后续通知</p>
      <div class=" jz">
        <VanImage
          fit="contain"
          width="260"
          height="260"
          :src="require('@/assets/image/yes_yes.png')"
        />
      </div>
    </Row>
    <Row v-else-if="no_yes_Status=='30001025'" class="is_id_box ">
      <p class="face_is_type_tile">您已同意本次调解</p>
      <p class="face_is_type_text">请您进行签字</p>
      <div class=" jz">
        <VanImage
          fit="contain"
          width="260"
          height="260"
          :src="require('@/assets/image/qianzi.png')"
        />
      </div>
      <Row class="btn_p ">
        <Button class="btn_bottom" block color="#F12020" @click="SetYes">签字确认</Button>
      </Row>
    </Row>
    <Row v-else class="is_id_box jz">
      <Loading size="40px" vertical>{{ is_id_text }}</Loading>
    </Row>
  </div>
</template>

<script type="text/jsx">
import Pdfh5 from 'pdfh5'
import axios from 'axios'
import 'pdfh5/css/pdfh5.css'
import { fetchList, getaxios, getaxiosdata, deleteaxios, PostData, PostPut } from '@/api/article'
import { Popup, Dialog, Area, Field, Loading, Toast, NavBar, Col, Row, TabbarItem, Divider, Tabbar, Image as VanImage, Uploader, Button, AddressEdit } from 'vant'
import HeadNavBar from '@/components/HeadNavBar'
import areaList from '@/assets/Area.js'
import Cookies from 'js-cookie'

export default {
  name: 'Index',
  components: {
    Popup,
    [Dialog.Component.name]: Dialog.Component,
    Row, Field,
    Col, Area,
    Button,
    AddressEdit,
    Toast,
    HeadNavBar, Loading, VanImage
  },
  data() {
    return {
      popup_show: false,
      face_is_text: '为保障您的权益，请先通过人脸识别',
      no_yes_Status: false,
      show: false,
      areaList_value_detailed: '',
      areaList_value: '',
      gps_is_area: false,
      value: '',
      areaList,
      searchResult: [],
      is_address_edit: false,
      is_id: false,
      is_id_text: '加载中',
      user_id: '',
      pdfh5: null,
      loading: '',
      url: '',
      id: '',
      face_is_type: false,
      authUrl: '',
      face_is: '',
      pdf_list: false,
      set_btn_url: false
    }
  },
  created() {
    const face_url_data = this.$route.query
    const id_list = this.$route.fullPath.split('?')[1]
    if (id_list.search('TYPE') != '-1') {
      const id_list_type = id_list.split('TYPE')
      this.user_id = id_list_type[0]
      this.face_is = id_list_type[1].substring(0, 3)
      if (this.face_is == 'yes') {
        Cookies.set('face_is', this.face_is)
        this.direct()
      } else {
        this.face_is_type = true
        this.GetRecognitionUrl('no')
      }
    } else {
      if (id_list) {
        this.user_id = id_list
        this.direct()
      } else {
        this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
        Toast.fail('用户标识有误请检查')
      }
    }
    //
    // if (this.$common.isEmpty(face_url_data.id)){
    //     let id_list = this.$route.fullPath.split('?')[1]
    //     if (id_list.search('TYPE')!='-1'){
    //         let id_list_type =id_list.split('TYPE')
    //         this.user_id = id_list_type[0]
    //         this.direct()
    //     }else {
    //         if (id_list.length>1){
    //             this.user_id = id_list[1]
    //             this.direct()
    //         } else {
    //             this.is_id_text =  '无法正确获取到用户id,请勿修改网页链接参数'
    //             Toast.fail('用户标识有误请检查');
    //         }
    //     }
    // }else {
    //     this.id = face_url_data.id
    //     this.GetSignUrl()
    //     this.face_is = face_url_data.face_is
    //     if (this.face_is=='yes'){
    //         sessionStorage.setItem("face_url_data",JSON.stringify(face_url_data)); //设置name为john
    //         // this.getdirect(this.id)
    //         this.GetDefAddr()
    //     } else {
    //         this.GetRecognitionUrl()
    //     }
    // }
    // 改变body的背景色
    // document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
    // this.loading=this.$loading({
    //   lock: true,
    //   text: '获取文书中请稍后',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // }),
  },

  mounted() {
    // axios
    // .get('https://www.gjtool.cn/pdfh5/git.pdf', {
    //   responseType: 'arraybuffer'
    // })
    // .then(res => {
    //   this.pdfh5 = new Pdfh5('#demo', {
    //     data: res.data
    //   });
    // });

    // //跨域代理 proxyTable
    // axios
    //   .get('/api/pdfh5/git.pdf', {
    //     responseType: 'arraybuffer'
    //   })
    //   .then(res => {
    //     this.pdfh5 = new Pdfh5('#demo', {
    //       data: res.data
    //     });
    //   });

    // //实例化
    //  this.pdfh5 = new Pdfh5("#demo", {
    //     pdfurl: "../../static/git.pdf"
    //  });
    //  //监听完成事件
    //  this.pdfh5.on("complete", function (status, msg, time) {
    //     console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
    //  })
  },
  methods: {
    async GetSignUrl() {
      await getaxiosdata(`/api/home/getSignUrl/${this.id}`).then(response => {
        if (response.code == '200') {
          const host = window.location.host
          if (host.search(172) != -1) {
            this.set_btn_url = `${window.location.protocol}//devcourt.smilou.com${response.data}`
          } else if (host.search('dev') != -1) {
            this.set_btn_url = `${window.location.protocol}//devcourt.smilou.com${response.data}`
          } else {
            this.set_btn_url = `${window.location.protocol}//wjcourt.smilou.com${response.data}`
          }
        } else {
          Toast.fail('获取签名地址失败')
        }
      })
    },
    async AreaYes() {
      const url_data = {
        caseInfoId: this.id,
        defAddr: this.areaList_value_detailed
      }
      await PostData(`/api/home/updateDef?caseInfoId=${this.id}&defAddr=${this.areaList_value_detailed}`).then(response => {
        if (response.data) {
          Toast.success('确认成功')
          this.GetconfirmStatus()
        } else {
          Toast.fail('确认失败请再次确认')
        }
      })
    },
    AreaonCancel() {
      this.gps_is_area = false
      this.$refs.myArea.reset()// 重置城市列表
    },
    AreaonChange(picker, index, value) {
      const val = picker.getValues()
      const areaName = ''
      for (var i = 0; i < val.length; i++) {
      }
      this.areaList_value = areaName
    },
    AreaConfirm(val) {
      this.areaList_value = `${val[0].name},${val[1].name},${val[2].name}`
      this.gps_is_area = false// 关闭弹框
    },
    GpsClickInput() {
      this.areaList_value = ''
      this.gps_is_area = true
    },
    AxiosPosType() {
      // Dialog.confirm({
      //     closeOnClickOverlay:true,
      //     title: '司法确认',
      //     confirmButtonText:'同意司法确认',
      //     cancelButtonText:'拒绝司法确认',
      //     message: '确认无误请同意司法确认，并进行签字。若不同意此调解内容请拒绝',
      // })
      //     // .then(() => {
      //     //     this.GstConfirmApply(true)
      //     // })
      //     // .catch(() => {
      //     //     this.GstConfirmApply(false)
      //     // });
      this.popup_show = true
    },
    // 司法确认
    GstConfirmApply(type) {
      const data = {
        caseInfoId: this.id,
        Confirm: type
      }
      PostData(`api/home/confirmApply?caseInfoId=${this.id}&isConfirm=${type}`).then(response => {
        if (response.code == 200) {
          if (response.data) {
            Toast.success(response.message)
            window.location = this.set_btn_url
          } else {
            Toast.fail(response.message)
            this.GetconfirmStatus()
          }
        } else {
        }
      })
    },
    async direct() {
      await getaxios(`/plaintiff/api/home/direct/${this.user_id}`).then(response => {
        if (response.code == 200) {
          const id = response.data.url.split('?')[1]
          this.id = id
          this.face_is = Cookies.get('face_is')
          const Cooki_face_id = Cookies.get('face_id')
          // console.log(this.$common.isEmpty(Cooki_face_id))
          // console.log( Cooki_face_id==id)
          // console.log( id)
          // console.log( Cooki_face_id)

          if (this.$common.isEmpty(Cooki_face_id) || Cooki_face_id == id) {
            Cookies.set('face_id', this.id)
            const face_id = Cookies.get('face_id')
            if (this.face_is == 'yes') {
              this.GetSignUrl()
              this.GetconfirmStatus()
            } else {
              this.face_is_type = true
              this.GetRecognitionUrl()
            }
          } else {
            Cookies.set('face_id', this.id)
            this.face_is_type = true
            this.GetRecognitionUrl()
          }
        } else {
          this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
        }
      })
    },
    SetWindowUrl() {
      window.location = this.authUrl
    },
    SetYes() {
      window.location = this.set_btn_url
    },
    async GetRecognitionUrl(type) {
      if (type == 'no') {
        this.this.face_is_text = '人脸识别失败，请再次识别'
      }
      const href = window.location.href
      const data_list = {
        successUrl: `${href}TYPEyes`,
        failUrl: `${href}TYPEno`
      }
      await getaxiosdata(`api/sign/faceRecognitionUrl`, data_list).then(response => {
        if (response.code == 200) {
          this.authUrl = response.data.authUrl
          this.face_is_type = true
        } else {
        }
      })
    },
    async GetDefAddr(id) {
      await getaxios(`api/home/getDefAddr/${this.id}`).then(response => {
        if (response.code == 200) {
          this.areaList_value_detailed = response.data.defAddress
          this.is_address_edit = true
        } else {
          this.is_id_text = '查询是否确认送达失败'
        }
      })

      // //判断是否已经修改了送达地址
      // let isDefConfirm = await getaxios(`api/home/confirmStatus/${this.id}`)
      // if (isDefConfirm.code =='200'){
      //     console.log(isDefConfirm,'isDefConfirm')
      //     this.no_yes_Status = isDefConfirm.data
      //     if(isDefConfirm.data=='30001026' ){//拒绝司法确认
      //
      //     }else if (isDefConfirm.data!=='30001024' || isDefConfirm.data!=='30001025' ||isDefConfirm.data!=='30001026' ||isDefConfirm.data!=='30001027' ||isDefConfirm.data!=='30001028'||  isDefConfirm.data!=='30001029'){
      //         this.getdirect(this.id)
      //     } else {
      //         await getaxios(`api/home/getDefAddr/${this.id}`).then(response => {
      //             console.log(response)
      //             if (response.code==200){
      //                 this.areaList_value_detailed = response.data.defAddress
      //                 this.is_address_edit=true
      //             }else {
      //                 this.is_id_text = '查询是否确认送达失败'
      //             }
      //         })
      //     }
      // } else {
      //
      // }
    },
    // 获取案件状态
    async GetconfirmStatus(id) {
      const isDefConfirm = await getaxios(`api/home/confirmStatus/${this.id}`)
      if (isDefConfirm.code == '200') {
        this.no_yes_Status = isDefConfirm.data
        if (isDefConfirm.data == '30001026') { // 拒绝司法确认
        } else if (isDefConfirm.data != '30001024' && isDefConfirm.data != '30001025' && isDefConfirm.data != '30001026' && isDefConfirm.data != '30001027' && isDefConfirm.data != '30001028' && isDefConfirm.data != '30001029') {
          this.GetDefAddr()
        } else if (isDefConfirm.data == '30001024') {
          this.getdirect(this.id)
        } else if (isDefConfirm.data == '30001027') {

        } else if (isDefConfirm.data == '30001025') {

        } else {
          await getaxios(`api/home/getDefAddr/${this.id}`).then(response => {
            if (response.code == 200) {
              this.areaList_value_detailed = response.data.defAddress
              this.is_address_edit = true
            } else {
              this.is_id_text = '查询是否确认送达失败'
            }
          })
        }
      } else {
      }
    },

    async getdirect(id) {
      await getaxios(`/api/home/getMediate/${id}`).then(response => {
        this.is_id = true
        if (response.code == 200) {
          this.loading = ''
          this.pdf_list = response.data.list
          for (const pdf_list_index in this.pdf_list) {
            axios
              .get(this.pdf_list[pdf_list_index].serverFilePath, {
                responseType: 'arraybuffer'
              })
              .then(res => {
                this.pdfh5 = new Pdfh5(`.pdf_${pdf_list_index}`, {
                  data: res.data
                })
              })
          }
        } else {
          this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
        }
      })
    }
  }

}
</script>

<style lang="less"  scoped>
  .popup_box_btn{
    padding: 0 10px;
    margin-bottom: 60px;
  }
  .popup_box{
    padding: 20px;
    .popup_box_text{
      font-size: 18px;
      line-height: 1.5;
      margin-bottom: 30px;
    }
  }

  .address_box{
    position: relative;
  }
  .pdf_box{
    padding: 0 10px;
  }
  .area_btn{
    margin-top: 40px;

  }
  .area_box{
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .btn_bottom{
    font-size: 16px;
  }
  .face_is_type_img_box{
    margin: 0 auto;
    position: relative;
    width: 230px;
    height: 200px;
    background: linear-gradient(0deg, #EE0A24, #FF6034);
    box-shadow: 1px 3px 27px 0px rgba(241, 32, 32, 0.43);
    border-radius: 10px;
  }
  .face_is_type_tile{
    padding-top: 50px;
    font-size: 22px;
    color: #F22020;
    line-height: 40px;
  }
  .face_is_type_text{
    font-size: 14px;
    color: #F22020;
    margin-bottom: 60px;

  }
  .is_id_box{
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
  }
  #pdf_demo{
    margin-bottom: 93px;
  }

  .pdf_h5_btn_box {
  }

  .pdf_h5_btn_box{
    text-align: center;
    margin: 20px 0 40px;
    width: 100%;
  }
  .pdf_h5_btn_text{
    font-size: 16px;
    margin: 16px 0 ;
  }

</style>
